export default function() {
	return {
		hiddenClasses: '',
		visibleClasses: '',
		isInView: false,
		threshold: 1,
		id: `scroll-reveal-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`,
		observer: null,

		init() {
			this.hiddenClasses = this.$el.getAttribute('x-enter') || '';
			this.visibleClasses = this.$el.getAttribute('x-leave') || '';

			let defaultThreshold = this.threshold;
			if (window.matchMedia("(max-width: 700px)").matches) {
				defaultThreshold = 0.5;
			}
			this.threshold = parseFloat(this.$el.getAttribute('x-threshold') || defaultThreshold);

			if (document.body.classList.contains('no-scroll-reveal')) {
				if (this.visibleClasses) {
					this.$el.classList.add(...this.visibleClasses.split(' ').filter(c => c.trim()));
				}
				return;
			}

			// etat initial
			if (this.hiddenClasses) {
				this.$el.classList.add(...this.hiddenClasses.split(' ').filter(c => c.trim()));
				if (!this.$el.classList.contains('duration')) {
					this.$el.classList.add('duration-1000');
				}
				if (!this.$el.classList.contains('transition')) {
					this.$el.classList.add('transition-all');
				}
			}

			this.setupIntersectionObserver();
			this.$cleanup = () => {
				if (this.observer) {
					this.observer.disconnect();
					this.observer = null;
				}
			};
		},

		setupIntersectionObserver() {
			this.observer = new IntersectionObserver((entries) => {
				const isIntersecting = entries[0].isIntersecting;

				if (isIntersecting && !this.isInView) {
					this.isInView = true;
					this.showElement();
				} else if (!isIntersecting && this.isInView) {
					// Optionnel: cache à nouveau les éléments qui quittent la vue
					// this.isInView = false;
					// this.hideElement();
				}
			}, {
				root: null,
				threshold: this.threshold,
				rootMargin: '0px 0px 0px 0px'
			});
			this.observer.observe(this.$el);
		},

		showElement() {
			if (this.hiddenClasses && this.visibleClasses) {
				this.$el.classList.add(...this.visibleClasses.split(' ').filter(c => c.trim()));
				this.$el.classList.remove(...this.hiddenClasses.split(' ').filter(c => c.trim()));
			}
		},

		hideElement() {
			if (this.hiddenClasses && this.visibleClasses) {
				this.$el.classList.add(...this.hiddenClasses.split(' ').filter(c => c.trim()));
				this.$el.classList.remove(...this.visibleClasses.split(' ').filter(c => c.trim()));
			}
		}
	};
}
